import styles from './PageProductHeader.module.css';
import useSearchParamOrDefaultProps from '../hooks/useSearchParamOrDefaultProps.js';
import PageProductHeaderLinkAuthFlow from './PageProductHeaderLinkAuthFlow.js';
import PageProductHeaderLogo from './PageProductHeaderLogo.js';

function PageProductHeader() {
  const {
    productSku,
    headerCallToActionDescription,
    headerCallToActionText,
    windowTopLocationHref = window.location.href,
  } = useSearchParamOrDefaultProps();

  const { origin } = new URL(windowTopLocationHref);

  return (
    <header className={styles.PageProductHeader}>
      <div className={styles.PageProductHeaderFlexbox}>
        <a href={origin} target="_top">
          <PageProductHeaderLogo
            id="CNBCLogo"
            backgroundImage={'var(--logoCNBC)'}
          />
        </a>
        <div className={styles.callToActionWrapper}>
          <span className={styles.callToActionDescription}>
            {headerCallToActionDescription || 'Subscribe now to'}
          </span>
          <PageProductHeaderLinkAuthFlow
            target="top"
            borderRadius="3px"
            fontWeight={600}
            whiteSpace="nowrap"
            contentType={'page'}
            modalType={'signUp'}
            productSku={productSku}
            letterSpacing={'1.09091px'}
            flexShrink="0"
            textAlign="center"
            id="headerCTA"
          >
            {headerCallToActionText}
          </PageProductHeaderLinkAuthFlow>
        </div>
      </div>
    </header>
  );
}

export default PageProductHeader;
